import { render, staticRenderFns } from "./MyAppointment.vue?vue&type=template&id=32abc916&"
import script from "./MyAppointment.vue?vue&type=script&lang=js&"
export * from "./MyAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports